import { useState } from 'react';
import { MuseumDataType } from '@portalCommon/constants';
import { ReactComponent as IconLeftArrow } from '@portalCommon/assets/svg/icon-left-arrow.svg';
import { ReactComponent as IconRightArrow } from '@portalCommon/assets/svg/icon-right-arrow.svg';
import { IconProcess } from '@portalCommon/components/Icon';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';

// import required modules
import { Autoplay } from 'swiper';
import 'swiper/css';

import { OptimizedImg } from '@commonPackage/components';
import cx from './index.module.less';

interface Props {
  dataSource: MuseumDataType[];
  className?: string;
}

export const TabCard = (props: Props) => {
  const { dataSource, className } = props;
  const [curIdx, setCurIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperClass>();
  const onSlideChange = (sw: SwiperClass) => {
    setCurIdx(sw?.activeIndex || 0);
  };
  return (
    <div className={cx(className, 'tab-card-container')}>
      <div className={cx('tabs')}>
        {dataSource.map((item, idx) => (
          <div
            className={cx('tab', { hover: curIdx === idx })}
            key={`${idx}_${item.title}`}
            onMouseEnter={() => swiper?.slideTo(idx)}>
            {item.title}
          </div>
        ))}
      </div>
      <Swiper
        onSwiper={sw => setSwiper(sw)}
        spaceBetween={30}
        centeredSlides={true}
        onSlideChange={onSlideChange}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        modules={[Autoplay]}
        className={cx('my-swiper')}>
        {dataSource.map(item => (
          <SwiperSlide key={item.imgSrc}>
            <div className={cx('content')}>
              <div className={cx('text-wrapper')}>
                <OptimizedImg
                  loading="lazy"
                  src="https://static.fuxi.netease.com/yaotai/web/index/ll68pyc4_319956.png"
                  alt=""
                />
                <div className={cx('text')}>{item.brief}</div>
              </div>
              <OptimizedImg loading="lazy" className={cx('image')} src={item.imgSrc} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={cx('page-select')}>
        <IconProcess className={cx('circle')} component={IconLeftArrow} onClick={() => swiper?.slidePrev()} />
        <div className={cx('page-num')}>
          <span className={cx('cur-page-num')}>{`0${curIdx + 1}`}</span>
          <span className={cx('total-page-num')}>--</span>
          <span className={cx('total-page-num')}>{`0${dataSource.length}`}</span>
        </div>
        <IconProcess className={cx('circle')} component={IconRightArrow} onClick={() => swiper?.slideNext()} />
      </div>
    </div>
  );
};
